import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { GlobalButton } from "../../styles";
import { FILE_ATTACHMENT_TABLE_COLUMNS } from "./constants";
import { downloadFile } from "../../../global";
import { IconButton } from "@mui/material";
import TrashIcon from "@mui/icons-material/Delete";
import {
    StyledTableBody,
    StyledTableCell,
    StyledTableRow,
    UXDataTableWithoutBody,
} from "../../../components/UXDataTable";
import FileDragAndDrop from "../../../components/FileDragAndDrop";


export default function WorkRequestFiles({

    disableForm,
    files,
    setFiles,
    openModalMessages,
}) {

    function handleChangeFile(property, index) {
        const listFiles = files.map((file, idx) => {
            if (index === idx && file.file?.id) {
                return {
                    ...file,
                    file: {
                        ...file.file,
                        [property]: !file.file[property],
                    },
                };
            } else if (index === idx) {
                return {
                    ...file,
                    [property]: !file[property],
                };
            }
            return file;
        });

        setFiles([...listFiles]);
    }

    function handleFiles(newFiles) {
        const listFiles = newFiles.map((item) => {
            return {
                file: item,
                sendWithShipment: false,
                isSDS: false,
            };
        });
        setFiles(files.concat(listFiles));
    }

    function deleteFile(file) {
        const newFiles = files.filter((f) => f !== file);

        setFiles(newFiles);
    }

    function HandleFileDownload(file) {
        downloadFile('workrequestfiles', file.fileName, file.filePath, openModalMessages)
    }


    return (
        <>
            <FileDragAndDrop
                disabled={disableForm}
                handleFiles={handleFiles}
                files={files.map((item) => item.file)}
                showFiles={false}
            ></FileDragAndDrop>
            <div
                style={{
                    width: "50%",
                    minWidth: "800px",
                }}
            >
                <UXDataTableWithoutBody
                    tableWidth="100%"
                    cols={FILE_ATTACHMENT_TABLE_COLUMNS}
                    blankFirstHeader={true}
                    tableId="midasFileAttachments"
                    rowLength={files.length}
                    enablePaging={false}
                    rowsPerPage={files.length}
                    page={0}
                    handleChangePage={null}
                    handleChangeRowsPerPage={null}
                    noDataFoundMessage={"No Files Added"}
                    enableAddIcon={false}
                    addFunction={() => null}
                    addToolTipText=""
                    isDataLoading={false}
                >
                    <StyledTableBody key={"myTablebody"}>
                        {files.map((file, rowIndex) => {
                            return (
                                <StyledTableRow hover key={`custom-row-${rowIndex}`}>
                                    <StyledTableCell component="th" scope="row">
                                        <IconButton
                                            aria-label="upload"
                                            component="span"
                                            onClick={() => deleteFile(file)}
                                            disabled={file.file.id ? true : false}
                                        >
                                            <TrashIcon />
                                        </IconButton>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <GlobalButton style={{ textTransform: "none" }} onClick={e => HandleFileDownload(file.file)}>{file.file.name}</GlobalButton>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={
                                                        file.file?.id
                                                            ? file.file.sendWithShipment
                                                            : file.sendWithShipment
                                                    }
                                                    onChange={(e) =>
                                                        handleChangeFile("sendWithShipment", rowIndex)
                                                    }
                                                ></Checkbox>
                                            }
                                            label={"Yes"}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={disableForm}
                                                    checked={
                                                        file.file?.id ? file.file.isSDS : file.isSDS
                                                    }
                                                    onChange={(e) =>
                                                        handleChangeFile("isSDS", rowIndex)
                                                    }
                                                ></Checkbox>
                                            }
                                            label={"Yes"}
                                        />
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </StyledTableBody>
                </UXDataTableWithoutBody>
            </div>
        </>);
}